import React, { useEffect } from 'react'

import styles from 'components/panels/panel.module.scss'
import usePanelContext from 'refactor/hooks/usePanelContext'

export default function PanelLoadingIndicator({
    label,
    error,
    onRetry,
}: {
    label?: string
    error?: string
    onRetry?: () => void
}) {
    const { setIsInitialLoading } = usePanelContext()

    // The header owns load feedback for the stream. Tie that feedback to this
    // shared loader's lifetime so initial navigation/loading gets the same halo
    // as a later reload without pretending it is a pull gesture.
    useEffect(() => {
        setIsInitialLoading?.(!error)
        return () => setIsInitialLoading?.(false)
    }, [setIsInitialLoading, error])

    return (
        <div className={styles.loader} aria-label={error || label}>
            {error ? (
                <div className={styles.loadingError} role="status">
                    <p>{error}</p>
                    <button type="button" onClick={onRetry}>
                        Retry
                    </button>
                </div>
            ) : (
                <div className={styles.loadingIcon}>
                    <i className="fa fa-circle-o-notch fa-spin fa-lg" />
                </div>
            )}
        </div>
    )
}
